/**
 * Centralized copy for the untranscribed-videos disclosure (M4S-5314).
 *
 * Collected videos whose files lack transcribable audio are excluded from the
 * synthesis; these formatters produce the one place that says so, per surface
 * (synthesis banner, transcript export, comparison footnote). Every surface
 * pulls from here so a wording change lands once.
 *
 * Wording is a PLACEHOLDER pending stakeholder review (M4S-5314).
 *
 * Callers only render a disclosure when the count is > 0 — zero or null/undefined
 * renders nothing — so these formatters never need an n <= 0 branch.
 *
 * Client-safe: pure string formatters, no imports.
 */

/** Synthesis-tab banner: exclusion sentence plus the still-viewable reassurance. */
export function formatUntranscribedBanner(n: number): string {
    return n === 1
        ? '1 video had no transcribable audio and was excluded from this analysis. It is still viewable in your responses.'
        : `${n} videos had no transcribable audio and were excluded from this analysis. They are still viewable in your responses.`;
}

/** Export line: the banner's exclusion sentence without the still-viewable coda. */
export function formatUntranscribedExportLine(n: number): string {
    return n === 1
        ? '1 video had no transcribable audio and was excluded from this analysis.'
        : `${n} videos had no transcribable audio and were excluded from this analysis.`;
}

/** Comparison footnote: notes the exclusion applies to every base size shown. */
export function formatUntranscribedFootnote(n: number): string {
    return n === 1
        ? '1 video had no transcribable audio and is excluded from all bases.'
        : `${n} videos had no transcribable audio and are excluded from all bases.`;
}
